module.exports = __webpack_public_path__ + "img/PR3.493da01e.gif";